import { ReactNode, ErrorInfo, Component, PropsWithChildren } from "react"

type ErrorBoundaryProps = PropsWithChildren<{
  fallbackComponent?: ReactNode | ((args: { error: Error; errorInfo: ErrorInfo }) => ReactNode)
  onError?: (args: { error: Error; errorInfo: ErrorInfo }) => void
}>

type ErrorBoundaryState = {
  hasError: boolean
  error: Error | null
  errorInfo: ErrorInfo | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo,
    })

    this.props.onError?.({ error, errorInfo })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallbackComponent && typeof this.props.fallbackComponent === "function") {
        return this.props.fallbackComponent({
          error: this.state.error as Error,
          errorInfo: this.state.errorInfo as ErrorInfo,
        })
      }

      return this.props.fallbackComponent
    }

    return this.props.children
  }
}
